import Service from '../../services'

// initial state
const DevData = {
    name: "DevData",
    stateFactory: true,
    namespaced: true,
    state: {
        // dataDev:{
        //     id:'',
        //     name_th: '',
        //     name_en: '',
        //     description_th: '',
        //     description_en: '',
        //     reference_th: '',
        //     reference_en: '',
        //     howto_th: '',
        //     howto_en: '',
        //     file_path: '',
        //     updated_at: '',
        // },
        dataDev: [],
        dataDevPaginate: [],
        dataGroup: []
    },
    mutations: {
        SET_DEV_DATA(state, data) {
            state.dataDev = data


            // eslint-disable-next-line no-console
            // console.log("state.dataDev", state.dataDev)
        },
        SET_GROUP_DATA(state, data){
            state.dataGroup = data

            // console.log("state.dataGroup", state.dataGroup)
        }

    },
    actions: {
        onGetAllDevData({ commit }) {
            // const powerBi = await Service.powerBi.getAllPowerBi();
            return Service.dataDev.getAllDevData().then(res => {
                commit('SET_DEV_DATA', res)
                return res;
            })
        },
        /**
         * Author: thiracupt ponngern
         * Details: get group ckan
         */
        onGetAllGroupCkan({ commit }) {
            // const powerBi = await Service.powerBi.getAllPowerBi();
            return Service.dataDev.getAllGroupCkan().then(res => {
                commit('SET_GROUP_DATA', res)
                return res;
            })
        },
        onGetGroupCkan({ commit }) {
            // const powerBi = await Service.powerBi.getAllPowerBi();
            return Service.dataDev.getGroupCkan().then(res => {
                commit('SET_DEV_DATA', res)
                return res;
            })
        },
        onAddDevData(data) {
            let data_create = data;
            // console.log("data_create", typeof (data_create))
            // console.log("data_create", data_create)
            return Service.dataDev.addDevData(data_create).then(res => {
                return res;
            })
        },
        // eslint-disable-next-line no-unused-vars
        onUpdateDevData({ commit }, data) {
            let id = data.id;
            let data_update = data;
            return Service.dataDev.updateDevData(id, data_update).then(res => {
                return res
            });
        },
        // eslint-disable-next-line no-unused-vars
        onDeleteDevData({ commit }, id) {
            return Service.dataDev.deleteDevData(id).then(res => {
                return res
            });
        },
        onImportExcel({ commit }, data) {
            return Service.dataDev.importExcel(data).then(res => {
                // console.log("imported", res)
                return res
            });
        }


    },
};
export default DevData;
